import { render } from "./Header.vue?vue&type=template&id=19bbe9b1"
import script from "./Header.vue?vue&type=script&lang=js"
export * from "./Header.vue?vue&type=script&lang=js"

import "./Header.vue?vue&type=style&index=0&id=19bbe9b1&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\game-forecast\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__